export default __webpack_public_path__ + "static/media/arrow-down.44b39faa.svg";